import React, { useEffect } from 'react';

import TemplatePage from './template';
import useSimplifiedRegistration from './hooks';

export default function SimplifiedRegistration() {
  const sharedProps = useSimplifiedRegistration();

  useEffect(() => {
    sharedProps.getInitialData();
  }, []);

  return <TemplatePage {...sharedProps} />
}
